export const environment = {
  production: true,
  //RUTA_API: "https://twapidev.indeone.app",
  //RUTA_API: "https://twperuapi.indeone.app",
  //RUTA_API: "https://twapiv2.indeone.app",
  RUTA_API: "https://terraapi.indeone.app",
  TOKEN: "INDESAD"
};
// RUTA_API = "https://twapiv2.indeone.app:20014",
// RUTA_API = "https://twperuapi.indeone.app:20014",
// RUTA_API = "https://twapidev.indeone.app:20014",

